import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    oauthClientName: {
      label: {
        id: 'properties.oauthClientName',
        defaultMessage: 'Client name',
        description: 'label of the form field oauth client',
      },
    },
    redirectUri: {
      label: {
        id: 'properties.redirectUri',
        defaultMessage: 'Redirect uri',
        description: 'label of the form field redirect uri',
      },
    },
    grantTypes: {
      label: {
        id: 'properties.grantTypes',
        defaultMessage: 'Grant types',
        description: 'label of the form field grant types',
      },
    },
    scopes: {
      label: {
        id: 'properties.scopes',
        defaultMessage: 'Scopes',
        description: 'label of the form field scopes',
      },
    },
    oauthClientID: {
      label: {
        id: 'properties.oauthClientID',
        defaultMessage: 'Client ID',
        description: 'label of the form field client id',
      },
      tooltip: {
        id: 'properties.oauthClientIDTooltip',
        defaultMessage: 'Copied client ID',
        description: 'label of the tooltip for copying',
      },
      button: {
        id: 'properties.oauthClientIDButton',
        defaultMessage: 'Copy client ID',
        description: 'label of the button for copying',
      },
    },
    oauthClientSecret: {
      label: {
        id: 'properties.oauthClientSecret',
        defaultMessage: 'Client secret',
        description: 'label of the form field client secret',
      },
      tooltip: {
        id: 'properties.oauthClientSecretTooltip',
        defaultMessage: 'Copied client secret',
        description: 'label of the tooltip for copying',
      },
      button: {
        id: 'properties.oauthClientSecretButton',
        defaultMessage: 'Copy client secret',
        description: 'label of the button for copying',
      },
    },
  },
  formActions: {
    cancel: {
      id: 'formActions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the form action cancel button',
    },
    save: {
      id: 'formActions.save',
      defaultMessage: 'Save',
      description: 'label of the form action save button',
    },
  },
};

export default defineMessages(translations);
